/* 车系详情 */
import React from 'react'
import get from 'lodash/get'
import Link from 'next/link'
import 'styled-jsx/css'
import getLinkHref from 'lib/get-link-href'
import fetch from 'isomorphic-unfetch'
import getUrl from 'lib/url'
import { getZT } from 'lib/zt-util'

import Image from 'Components/image'
import Button from 'Components/button'
import { useCityName } from 'Components/hooks'
import { sendTeaCommEvent } from 'lib/tea-analyze'

export interface IHeader {
  brand_name: string
  brand_id: string
  avatar_url: string
  cover_url: string
  dealer_price: string
  official_price: string
  name: string
  head_info: string
  extra: string
  entrance_list: string
  series_id: number
  car_id_list: string
  pic_summary: IImages[]
  white_cover_url: string
  motor_id: number
}
export interface IExtra {
  car_type?: string
  oil_consume?: string
}
// interface IImages {
//   num: number
//   info: {
//     image_num: number
//     tab_title: string
//     interior_vr_url: string
//     appear_360_img_list: string[]
//     cover: string
//   }
// }
interface IImages {
  SeriesId?: number
  Category?: string
  PicCount?: number
  CoverPicUrl: string
}
interface IProps {
  seriesId: number
}

export default function Header({ seriesId }: IProps) {
  const [params, setParams] = React.useState<IHeader>({
    brand_name: '',
    brand_id: '',
    avatar_url: '',
    cover_url: '',
    dealer_price: '',
    official_price: '',
    name: '',
    head_info: '',
    extra: '',
    entrance_list: '',
    series_id: seriesId,
    car_id_list: '',
    pic_summary: [],
    white_cover_url: '',
    motor_id: 0,
  })

  const cityName = useCityName()
  const [price, setPrice] = React.useState('')
  React.useEffect(() => {
    fetch(
      getUrl(
        `/motor/car_page/m/v1/get_head/?series_id=${seriesId}&city_name=${encodeURIComponent(
          cityName || '北京'
        )}&data_from=pc_station`
      )
    )
      .then(res => res.json())
      .then(res => get(res, 'concern_obj'))
      .then(data => {
        if (!data) return
        setParams(data)
      })

    fetch(
      getUrl(
        `/cloud/api/invoke/get_price_by_series_id?series_id=${seriesId}&city_name=${encodeURIComponent(
          cityName || ''
        )}`
      )
    )
      .then(res => res.json())
      .then((res: any) => {
        if (
          !res ||
          !res.data ||
          !res.data.DealerLowPrice ||
          !res.data.DealerHighPrice
        ) {
          return
        }
        setPrice(`${res.data.DealerLowPrice}万-${res.data.DealerHighPrice}万`)
      })
  }, [seriesId, cityName])

  function CarParams({ params }: { params: IHeader }) {
    let extra: IExtra
    try {
      extra = JSON.parse(params.extra)
    } catch {
      return null
    }

    const subsidyPrice = get(params, 'subsidy_price', '')
    const pirceHintText = subsidyPrice ? '补贴价格：' : '厂商指导价：'
    const priceText = subsidyPrice
      ? subsidyPrice
      : get(params, 'official_price', '')

    return (
      <section className="fl">
        <h1 className="name">{params.name}</h1>
        <div className="clearfix">
          <div className="price fl">
            <p className="dealer">
              经销商报价：
              <span className="price-line">{price}</span>
            </p>
            <p>
              {pirceHintText}
              <span>{priceText || '暂无报价'}</span>
            </p>
          </div>
          <div className="param fl">
            <p>厂商：{params.brand_name}</p>
            <p className="type">级别：{extra.car_type}</p>
          </div>
          {extra.oil_consume && (
            <div className="consume fl">
              <p>
                {extra.oil_consume.indexOf('排量') > -1
                  ? extra.oil_consume.replace(/排量 /, '排量：')
                  : extra.oil_consume.replace(/续航 /, '续航：')}
              </p>
            </div>
          )}
        </div>
        <Link
          href={`/dealer?seriesId=${seriesId}&zt=${getZT(
            'pc_series_top_title'
          )}`}
          as={`/dealer/${seriesId}?zt=${getZT('pc_series_top_title')}`}
        >
          <Button
            onClick={() => {
              sendTeaCommEvent('click_series_top_inquiry', {
                car_series_id: seriesId,
              })
            }}
            type="primary"
            disabled={
              !params.dealer_price || params.dealer_price.indexOf('暂无') >= 0
            }
            className={`button button-price`}
          >
            询底价
          </Button>
        </Link>
        <Link
          href={`/auto/params?carIds=${params.car_id_list}`}
          as={`/auto/params?carIds=${params.car_id_list}`}
        >
          <Button
            className={`button-param button button-config`}
            onClick={() => {
              sendTeaCommEvent('click_series_top_config', {
                car_series_id: seriesId,
              })
            }}
          >
            参数配置
          </Button>
        </Link>
        <Link href={`/community/${seriesId}`}>
          <Button
            className={`button-param button button-config`}
            onClick={() => {
              sendTeaCommEvent('click_series_page_top_forum_button', {
                car_series_name: params.name,
                car_series_id: seriesId,
                series_module_name: '',
                button_text: '车友圈',
              })
            }}
          >
            车友圈
          </Button>
        </Link>
        <style jsx>
          {`
            section {
              margin-left: 40px;
            }
            .name {
              line-height: 40px;
              margin-top: 25px;
              margin-bottom: 12px;
              font-size: 28px;
              font-weight: 500;
            }
            .price {
              padding-right: 16px;
            }
            .param {
              padding-left: 15px;
              padding-right: 16px;
              border: 1px solid #e6e6e6;
              border-top: 0;
              border-bottom: 0;
            }
            .consume {
              padding-left: 15px;
            }
            .type {
              margin-top: 12px;
            }
            p {
              line-height: 22px;
              font-size: 16px;
              color: #666;
            }
            p > span {
              color: #1a1a1a;
            }
            .dealer {
              line-height: 33px;
              margin-top: -7px;
              margin-bottom: 7px;
            }
            .dealer > span {
              font-size: 24px;
              font-weight: 500;
              vertical-align: top;
              color: #ff9100;
            }
            section :global(.button) {
              min-width: 200px;
              height: 36px;
              margin-top: 20px;
              line-height: 36px;
              font-size: 16px;
              font-weight: normal;
            }
            section :global(.button-param) {
              margin-left: 8px;
              border: solid 1px #cccccc;
            }
          `}
        </style>
      </section>
    )
  }

  if (params.brand_name === '') return null

  return (
    <section className="box clearfix">
      <Photos params={params} seriesId={seriesId} cityName={cityName} />
      <CarParams params={params} />
      <style jsx>
        {`
          section {
            padding: 12px;
            border: solid 1px #e6e6e6;
          }
        `}
      </style>
    </section>
  )
}

type HeaderProps = {
  params: IHeader
  seriesId: number
  cityName?: string
}

const Photos: React.FC<HeaderProps> = props => {
  const { params, seriesId } = props

  const images: IImages[] = params.pic_summary.slice(0, 3)
  if (images.length === 0) {
    images[0] = {
      SeriesId: seriesId,
      Category: '',
      PicCount: 0,
      CoverPicUrl: '',
    }
  }
  images[0].CoverPicUrl = params.white_cover_url
  const num =
    images.reduce((pre: number, cur) => {
      return pre + (cur.PicCount || 0)
    }, 0) || 0
  const categoryMap = new Map()
  categoryMap.set('wg', '外观')
  categoryMap.set('ns', '内饰')
  categoryMap.set('kj', '空间')

  return (
    <section className="fl clearfix">
      <Link
        href={`/auto/images/list?seriesId=${seriesId}`}
        as={getLinkHref(`/auto/series/${seriesId}/images`)}
      >
        <a target="_blank">
          <div className="cover fl">
            <Image src={params.cover_url} />
            <p className="num">共{num}张图 &gt;&gt;</p>
            <div className="mask" />
          </div>
        </a>
      </Link>

      <div className="photos fl">
        {images.length &&
          images.map((item: IImages) => {
            const category = categoryMap.get(item.Category)
            return (
              <div
                className="small-cover"
                key={item.Category}
                onClick={() => {
                  sendTeaCommEvent('click_series_top_pic', {
                    car_series_id: seriesId,
                    sub_tab: category,
                  })
                }}
              >
                <Link
                  key={category}
                  href={`/auto/images/list?tab=${item.Category}&seriesId=${seriesId}`}
                  as={getLinkHref(
                    `/auto/series/${seriesId}/images?tab=${item.Category}`
                  )}
                >
                  <a target="_blank">
                    <Image src={item.CoverPicUrl} />
                    <p className="num text">{category}</p>
                    <div className="mask" />
                  </a>
                </Link>
              </div>
            )
          })}
      </div>
      <style jsx>
        {`
          .cover {
            position: relative;
            overflow: hidden;
            width: 330px;
            height: 220px;
          }
          .num {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            line-height: 28px;
            text-align: center;
            color: #fff;
            background-color: rgba(0, 0, 0, 0.6);
          }
          .photos {
            width: 107px;
            margin-left: 4px;
          }
          .photos > div {
            position: relative;
            overflow: hidden;
            height: 70px;
            margin-bottom: 5px;
          }
          .photos > div:last-child {
            margin-bottom: 0;
          }
          .text {
            line-height: 16px;
            font-size: 12px;
          }
          .small-cover {
            cursor: pointer;
          }
          .mask {
            width: 100%;
            height: 100%;
            background-color: #000000;
            opacity: 0.08;
            position: absolute;
            top: 0;
            left: 0;
          }
        `}
      </style>
    </section>
  )
}
